import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4FeedbackGivenEventProps extends GA4GeneralProps {
  componentClass: string | null
  customInput?: string | null
  feedbackClass?: string | null
  feedbackName?: string | null
  feedbackMethod?: string | null
}

export class GA4FeedbackGivenEvent extends GA4Event {
  ga4_custom_input: string | null
  ga4_feedback_class: string | null
  ga4_feedback_name: string | null
  ga4_feedback_method: string | null

  constructor({
    customInput = null,
    feedbackClass = null,
    feedbackName = null,
    feedbackMethod = null,
    ...generalProps
  }: GA4FeedbackGivenEventProps) {
    super({ event: EVENT.FEEDBACK_GIVEN, ...generalProps })

    this.ga4_custom_input = customInput
    this.ga4_feedback_name = feedbackName
    this.ga4_feedback_class = feedbackClass
    this.ga4_feedback_method = feedbackMethod
  }
}
